module.exports = __webpack_public_path__ + "img/logo.fbdcc87d.png";